'use strict';

(function() {
	angular.module('onboarding.carrier')
		.directive('cobCarrierProfile', cobCarrierProfile);

	cobCarrierProfile.$inject = [
		'$timeout', 'sessionService', 'subjectObserverMessagesService', 'observerService', 'carrierRegistrationService'
	];

	var $timeout, sessionService, subjectObserverMessagesService, observerService, carrierRegistrationService;
	var subjectMessages, observerMessages;

	function cobCarrierProfile(_$timeout_,
		_sessionService_,
		_subjectObserverMessagesService_,
		_observerService_,
		_carrierRegistrationService_) {
		$timeout = _$timeout_;
		sessionService = _sessionService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		carrierRegistrationService = _carrierRegistrationService_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/carrier/profile/carrierProfile.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {
		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

		}
	}

})();
